import type { ButtonFloatingDto } from '@checkfront/guest-widgets-editor-api-api-client-javascript-axios';

export const mapToFloating = (value?: string) => {
  const position = value?.toLowerCase().trim();
  if (position === 'bottomright') return { position: 'BottomRight' } as ButtonFloatingDto;
  if (position === 'middleright') return { position: 'MiddleRight' } as ButtonFloatingDto;
  return undefined;
};
